export default (str: string): string => {
	return (
		str
			?.split(' ')
			.map((word) => word.charAt(0).toUpperCase())
			.slice(0, 2)
			.join('') || ''
	);
};
